import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutOrderPoolContainerTrailer_ArrivalTime extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 抵达时间
     */
    ArrivalTime?: Date;
    /**
     * 驶离时间
     */
    LeaveTime?: Date;
}

/**
 * -表单校验
 */
export const DtoPutOrderPoolContainerTrailer_ArrivalTimeRules = {
    ArrivalTime: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
}

/**
 * -设置项
 */
export const DtoPutOrderPoolContainerTrailer_ArrivalTimeMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "ArrivalTime",
    Label: "抵达时间",
    Customize: true,
  },
  {
    Prop: "LeaveTime",
    Label: "驶离时间",
    Customize: true,
  },
]
